<template>
  <div class="page" :key="Date.now()">
    <div style="width: 100%; display: flex; justify-content: center;">
      <TopBar></TopBar>
    </div>
    <div class="title">Algorithm Details</div>
    <div v-if="readyAlgo" class="algoName">{{algorithm.name}}</div>
    <div class="contents">
      <AlgoCard v-if="readyAlgo" :data="algorithm"></AlgoCard>
      <div>&nbsp;</div>
      <GridCard v-if="gcReady" :data="grid"></GridCard>
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/TopBar";
import AlgoCard from "@/components/AlgoCard";
import GridCard from "@/components/GridCard";
import {apiAlgos} from "@/api/algos";
import {apiGrid} from "@/api/grid";
import {apiQuestions} from "@/api/questions";
import {ref} from "vue"

export default {
  name: "Random",
  props: {
    algoId: {
      type: String,
      default: String(Math.floor(Math.random()*14) + 1)
    }
  },
  components: {
    TopBar,
    AlgoCard,
    GridCard
  },
  data() {
    let algorithms = ref([]);
    let grids = ref([]);
    let questions = ref([]);
    let readyAlgo = ref(false);
    let readyGrid = ref(false);
    let readyQuestion = ref(false);
    apiAlgos(algorithms, readyAlgo);
    apiGrid(grids, readyGrid);
    apiQuestions(questions, readyQuestion);
    let algo = String(Math.floor(Math.random() * 14) + 1);
    let isRandom = true;
    if (this.algoId) {
      algo = this.algoId;
      isRandom = false;
    }

    return {
      algorithms: algorithms,
      questions: questions,
      grids: grids,
      readyAlgo: readyAlgo,
      readyGrid: readyGrid,
      readyQuestion: readyQuestion,
      rnd: 0,
      realAlgoId: algo,
      isRandom: isRandom
    }
  },
  created() {
    if (this.isRandom) {
      this.realAlgoId = String(Math.floor(Math.random() * 14) + 1);
    }
  },
  computed: {

    gcReady() {
      return this.readyGrid && this.readyAlgo;
    },
    algorithm() {
      return this.algorithms[this.realAlgoId - 1];
    },
    grid() {

      let resp = []
      let grd = this.grids.assignments[this.realAlgoId - 1];

      for (let qid in grd) {
        if (this.questions[qid] && grd[qid]) {
          resp.push({
            qtext: this.questions[qid].text,
            qans: grd[qid]
          })
        }
      }
      return resp;
    }
  }

}
</script>

<style scoped>
.page {
  width: 900px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

}
.title {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
  flex-basis: 100%;
}

.contents{
  width: 100%;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.algoName{
  width:100%;
  font-size: 40px;
  font-weight: bolder;
  flex-shrink: 0;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>